import { render, staticRenderFns } from "./VirtualDespatchingTable.vue?vue&type=template&id=782d49a8&scoped=true&"
import script from "./VirtualDespatchingTable.vue?vue&type=script&lang=js&"
export * from "./VirtualDespatchingTable.vue?vue&type=script&lang=js&"
import style0 from "./VirtualDespatchingTable.vue?vue&type=style&index=0&id=782d49a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "782d49a8",
  null
  
)

export default component.exports